/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SqlStatistics,
} from '../models';
import {
    SqlStatisticsFromJSON,
    SqlStatisticsToJSON,
} from '../models';

/**
 * 
 */
export class SqlStatisticsControllerApi extends runtime.BaseAPI {

    /**
     */
    async clearSqlStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SqlStatistics>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admsys/sql/clear`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SqlStatisticsFromJSON));
    }

    /**
     */
    async clearSqlStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SqlStatistics>> {
        const response = await this.clearSqlStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSqlStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SqlStatistics>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admsys/sql/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SqlStatisticsFromJSON));
    }

    /**
     */
    async getSqlStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SqlStatistics>> {
        const response = await this.getSqlStatisticsRaw(initOverrides);
        return await response.value();
    }

}
